import React from "react";
import { motion } from "framer-motion";

import styles from "./styles.module.scss";

const Item = ({ data }) => {
  return (
    <div
      className={styles.item__wrapper}
      style={{ backgroundImage: `url(${data.imagePath})` }}
    >
      <h3>{data.title}</h3>
      <h5>{data.time}</h5>
    </div>
  );
};

export default Item;
